module.exports = __webpack_public_path__ + "img/logo.60eef70b.png";